<mat-dialog-content color="primary">{{data.message}}</mat-dialog-content>

<mat-dialog-actions>
	<button mat-button mat-dialog-close>OK</button>
</mat-dialog-actions>
